import React, {useEffect, useState} from 'react';
import '../App.css';
import { Button } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import Grilla from './grilla'
import Axios from 'axios';
import Bodyheaderloged from './bodyheaderloged'
import { Alert } from 'react-bootstrap';
function Bodycasinos (props){
    const navigate = useNavigate();
    const [casinos, setCasinos] = useState([])
    const [enterprises, setEnterprises] = useState([])
    const [nombrecasino, setNombreCasino] = useState('')
    const [direccioncasino, setDireccionCasino] = useState('')
    const [valorticketcasino, setValorticketCasino] = useState('')
    const [enterpriseidcasino, setEnterpriseidCasino] = useState('')
    const [tituloAlert, setTituloAlert] = useState('')
    const [textoAlert, setTextoAlert] = useState('')
    const [claseAlert, setClaseAlert] = useState('')
    const [alert, setAlert] = useState(false);
    const [classWaitProcess, setClassWaitProcess] = useState('waitProcess')
    let statuscall = '' 

    const enterpriseList = enterprises.map((item, i) => 
        <option key={i} value={item.rut}>{item.nombre}</option>
    )

    const createCasino = async (e) =>{
        setClassWaitProcess('waitProcessV')
        if(nombrecasino != '')
        {
            if(direccioncasino != '')
            {
                if(valorticketcasino != '')
                {
                    if(enterpriseidcasino != '')
                    {
                        let authcode = window.localStorage.getItem('MY_APP_STATE_AUTHCODE').replace('"', '')
                        const data = {   
                            nombre: nombrecasino,
                            direccion: direccioncasino,
                            valor_ticket: valorticketcasino,
                            enterprise_id: enterpriseidcasino
                        };
                        
                        const beneficiarioCreate = await Axios.post(process.env.REACT_APP_URLCREATECASINO, data, {
                            timeout: process.env.REACT_APP_TIMEOUT,
                            headers: {
                                'Access-Control-Allow-Origin' : '*',
                                'Access-Control-Allow-Methods': 'GET, POST',
                                'Access-Control-Allow-Headers': 'Content-Type'
                            }}).then(res => statuscall = res).catch(err => statuscall = err.response);
                                
                            if(statuscall.status == 200)
                            {
                                setClassWaitProcess('waitProcess')
                                casinos.push(data);
                                let copycasinos = casinos 
                                setCasinos(copycasinos)
                                setNombreCasino('')
                                setDireccionCasino('')
                                setValorticketCasino('')
                                setTituloAlert('Ingreso de casinos')
                                setTextoAlert('Casino agregado')
                                setClaseAlert('success alertFlotante opacity-100')
                                setAlert(true)
                                setTimeout(() => {
                                    setAlert(false)
                                    navigate('/Casinos/' + authcode.replace('"', ''))
                                }, 4000)
                            }
                            else
                            {
                                if(statuscall.status == 0)
                                {
                                    setClassWaitProcess('waitProcess')
                                    setTituloAlert('Ingreso de casinos')
                                    setTextoAlert('Servidor no responde. Intentelo mas tarde.')
                                    setClaseAlert('danger alertFlotante opacity-100')
                                    setAlert(true)
                                    setTimeout(() => {
                                        setAlert(false)
                                    }, 4000)                                    
                                }
                                
                            }
                    }
                    else
                    {
                        setClassWaitProcess('waitProcess')
                        setTituloAlert('Ingreso de casinos')
                        setTextoAlert('Debe seleccionar una empresa.')
                        setClaseAlert('warning alertFlotante opacity-100')
                        setAlert(true)
                        setTimeout(() => {
                            setAlert(false)
                        }, 4000)
                    }
                }
                else
                {
                    setClassWaitProcess('waitProcess')
                    setTituloAlert('Ingreso de casinos')
                    setTextoAlert('Debe ingresar valor ticket del casino.')
                    setClaseAlert('warning alertFlotante opacity-100')
                    setAlert(true)
                    setTimeout(() => {
                        setAlert(false)
                    }, 4000)
                }
            }   
            else
            {
                setClassWaitProcess('waitProcess')
                setTituloAlert('Ingreso de casinos')
                setTextoAlert('Debe ingresar una direccion.')
                setClaseAlert('warning alertFlotante opacity-100')
                setAlert(true)
                setTimeout(() => {
                    setAlert(false)
                }, 4000)
            }
        }
        else
        {
            setClassWaitProcess('waitProcess')
            setTituloAlert('Ingreso de casinos')
            setTextoAlert('Debe ingresar un nombre.')
            setClaseAlert('warning alertFlotante opacity-100')
            setAlert(true)
            setTimeout(() => {
                setAlert(false)
            }, 4000)
        }
    }

    const handleNombre = async (e) =>{
        setNombreCasino(e.target.value)
    }

    const handleDireccion = async (e) =>{
        setDireccionCasino(e.target.value)
    }    

    const handleValorTicket = async (e) =>{
        setValorticketCasino(e.target.value)
    }    

    const handleEmpresa = async (e) =>{
        setEnterpriseidCasino(e.target.value)
    }



    useEffect(() => {
        Axios.get(process.env.REACT_APP_URLGETENTERPRISES, {
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setEnterprises(response.data.enterprises)
        }).catch(error => {
            return error     
        });
    },[]);

    return (
        <div className='sshbodyappContainerLogin'>
            <div className='sshbodyappContainerRegister'>
                <Bodyheaderloged mailloginP={props.mailloginP} apptokenP={props.apptokenP} setStateMailP={props.setStateMailP}/>
            </div>

            <div className='sshbodyappContainerLoginForm'>
                <div className='container'>

                    <div className='row'>

                        <div className='col col-lg-8 col-md-8 col-sm-12'>
                            <div className='row'>

                                <div className='col col-lg-5 col-md-5 col-sm-12 divAbsolute'>
                                    <div className={classWaitProcess}>
                                        <div className='loaderS'>
                                        </div>
                                    </div>
                                </div>

                                <div className='col col-lg-5 col-md-5 col-sm-12 divAbsolute'>
                                    {alert
                                    ?<Alert variant={claseAlert} onClose={() => setAlert(false)} dismissible fade show>
                                        <Alert.Heading>{tituloAlert}</Alert.Heading>
                                            <p>
                                                {textoAlert}
                                            </p>
                                    </Alert>
                                    :''
                                    }
                                </div>

                                <div className='col col-lg-12 col-md-8 col-sm-12'>
                                    <div className='boSeccionForm'>

                                        <div className='boSeccionFormTitle'>
                                            Agregar nuevo casino
                                        </div>

                                        <div className='boControlForm'>
                                            <div className='boControlFormTitulo'>
                                                Nombre casino
                                            </div>
                                            <div className='boControlFormContent'>
                                                <input type="text" value={nombrecasino} onChange={handleNombre}></input>
                                            </div>
                                        </div>
                                        <div className='boControlForm'>
                                            <div className='boControlFormTitulo'>
                                                Dirección casino
                                            </div>
                                            <div className='boControlFormContent'>
                                                <input type="text" value={direccioncasino} onChange={handleDireccion}></input>
                                            </div>
                                        </div>
                                        <div className='boControlForm'>
                                            <div className='boControlFormTitulo'>
                                                Valor Ticket $
                                            </div>
                                            <div className='boControlFormContent'>
                                                <input type="text" value={valorticketcasino} onChange={handleValorTicket}
                                                        onKeyPress={(event) => {
                                                            if (!/[0-9]/.test(event.key)) {
                                                                event.preventDefault();
                                                            }
                                                        }
                                                }></input>
                                            </div>
                                        </div>
                                        <div className='boControlForm'>
                                            <div className='boControlFormTitulo'>
                                                Seleccione Empresa
                                            </div>
                                            <div className='boControlFormContent'>
                                                <select onChange={handleEmpresa}>
                                                    <option>Seleccione Empresa</option>
                                                    {enterpriseList}
                                                </select>
                                            </div>
                                            <div className='boControlFormAditionalContent'>
                                                <button onClick={createCasino}>
                                                    Crear
                                                </button>
                                            </div>
                                        </div>

                                    </div>     
                                </div>

                                <div className='col col-lg-12 col-md-8 col-sm-12'>
                                    <Grilla/>
                                </div>

                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>            
    )
}
export default Bodycasinos